import { useDebouncedCallback, useMountEffect } from "@react-hookz/web";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";

import { appAtom } from "~/lib/app/atoms";

export const useDocumentBodyScrollLock = () => {
  const [state, setState] = useAtom(appAtom);
  const [initialScroll, setInitialScroll] = useState("");

  useMountEffect(() => {
    setInitialScroll(window.getComputedStyle(window.document.body).overflowY);
  });

  useEffect(() => {
    window.document.body.style.overflowY = state.lockDocumentBodyScroll ? "hidden" : initialScroll;
  }, [initialScroll, state]);

  const lockDocumentBodyScroll = useDebouncedCallback(
    (lock: boolean) => {
      setState(state => ({
        ...state,
        lockDocumentBodyScroll: lock,
      }));
    },
    [],
    100,
  );

  return { lockDocumentBodyScroll };
};
